export default class PluginFactory {
    // #region Vars
    _plugins = new Map();
    // #endregion
    // #region Boostrap
    register(options) {
        // #region Compile
        var tInstance = {
            //Defaults
            name: options.name,
            //Interaction
            startup: options.startup,
            register: options.register,
            boostrap: options.boostrap,
            //System
            $host: host,
            $store: host.store,
            $options: options,
            $utils: utils,
        };
        let methods = options.methods;
        if (methods) {
            for (const key in methods) {
                const methodHandler = methods[key];
                if (utils.isFunction(methodHandler)) {
                    Object.defineProperty(tInstance, key, {
                        value: methodHandler.bind(tInstance),
                        configurable: true,
                        enumerable: true,
                        writable: true
                    });
                }
            }
        }
        // #endregion
        // #region Append
        this._plugins.set(options.name, tInstance);
        // #endregion
        // #region Register
        if (tInstance.register) {
            tInstance.register();
        }
        // #endregion
    }
    // #endregion
    // #region Startup, Boostrap
    runStartUp() {
        this._plugins.forEach(e => {
            if (e.startup) {
                e.startup();
            }
        });
    }
    runBoostrap(data) {
        this._plugins.forEach(e => {
            if (e.boostrap) {
                e.boostrap(data);
            }
        });
    }
}
